export default __webpack_public_path__ + "static/media/vkpic8.850e652e.png";